cafm.rb.eq = {

    setupAddEquipment: function (defaultCriteria) {
        
        $('#equipmentSwoFilters').bindViewModel(defaultCriteria);
    },
    getRoomBookingEquipment: function(){

        var roomBooking = cafm.views.getMainFormViewModel();

        if (roomBooking.Equipment) {

            cafm.util.convertAllUTCToSessionDateTimes(roomBooking.Equipment, ['FromTime', 'ToTime']);
        }
        else {

            roomBooking.set('Equipment', []);
        }

        var list = isFunc(roomBooking.Equipment.toJSON) ? roomBooking.Equipment.toJSON() : roomBooking.Equipment;
        
        return cafm.util.where(list, function (eq) {

            return !cafm.util.isTrue(eq.IsDeleted);
        });
    },
    getEquipmentRequestItems: function() {

        var equipmentReq = cafm.rb.eq.getEquipmentRequestViewModel();

        return cafm.util.ensureValue(equipmentReq.Items, []);
    },
    getEquipmentRequestViewModel: function () {

        var equipmentReq = $('#editEquipmentReqFieldSet').getViewModel();

        // if this is null we assume this is an edit and the vm is bound to the whole action window
        if (isNullOrUndefined(equipmentReq)) {

            equipmentReq = cafm.views.getActionWindowViewModel();
        }

        return equipmentReq;
    },
    handlers: {

        add: {
            
            selectSwo: function (e) {

                var tr = $(e.currentTarget).parents('tr:first');
                var grid = $('#equipmentSwoGrid').getGrid().data('kendoGrid');

                if (grid) {

                    var eqAsset = grid.dataItem(tr);

                    if (eqAsset) {

                        cafm.rb.eq.helpers.addEquipment(eqAsset);
                    }
                }
            },
            add: function (e) {

                var roomBooking = cafm.views.getMainFormViewModel();

                if (!roomBooking.Equipment) {

                    roomBooking.Equipment = [];
                }

                var eqReq = cafm.rb.eq.getEquipmentRequestViewModel().toJSON();

                if (!cafm.rb.eq.helpers.ensureIsRequired(eqReq)) {

                    return;
                }

                // ensure correct dates
                if (isDate(eqReq.FromTime)) {

                    eqReq.FromTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                    eqReq.FromTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                }

                if (isDate(eqReq.ToTime)) {

                    eqReq.ToTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                    eqReq.ToTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                }

                roomBooking.Equipment.push(eqReq);

                // refresh the equipment
                cafm.rb.eq.helpers.refreshEquipment();

                // close the action window
                cafm.views.closeActionWindow();
            },
            cancel: function () {

                cafm.toolbar.standardActionToolbar.cancel();
            },
            init: function(panel){
                
                $('.winButtons .btn[data-key="Add"]').hide();
            },
            load: function (panel) {

                panel.find('#equipmentSwoSearchBtn').click(cafm.rb.eq.handlers.search);

                var tbox = panel.find('.searchDescription > .cfTextInput');

                var tboxSearchHandle = function () {

                    panel.find('.searchBtn').click();
                }

                // hook up enter pressed to the search btn
                tbox.enterPressed(tboxSearchHandle);

                // hookup auto complete select event to the search button
                tbox.data('autocompleteselect', tboxSearchHandle);
            },
            swoGridItemDataBound: function (args) {

                if (!args.sender.element.data('initialising')) {

                    var data = args.sender.dataSource.data();
                    if (data && data.length == 1) {

                        var eqAsset = data[0];
                        cafm.rb.eq.helpers.addEquipment(eqAsset);
                    }
                }

                args.sender.element.off('click.cafm').on('click.cafm', '.addLink', cafm.rb.eq.handlers.add.selectSwo);
            }
        },
        addGridItemDataBound: function(args){

            if (!args.sender.element.data('initialising')) {

                var data = args.sender.dataSource.data();
                if (data && data.length == 1) {

                    var eqAsset = data[0];
                    cafm.rb.eq.helpers.addEquipment(eqAsset);
                }
            }

            args.sender.element.off('click.cafm').on('click.cafm', '.addLink', cafm.rb.eq.handlers.addEquipment);
        },
        editEquipmentGridItem: function(args) {

            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#equipmentGrid').getGrid().data('kendoGrid');

            if (grid) {

                var eqReq = grid.dataItem(tr);

                if (eqReq) {

                    cafm.views.openActionWindow({
                        url: cafm.url.get('RoomBooking/EditEquipmentRequest/{0}', eqReq.ID),
                        method: 'GET',
                        isForm: true,
                        viewModel: cafm.util.clone(eqReq),
                        winOptions: {
                            width: 600,
                            height: 450
                        },
                        onLoad: cafm.rb.eq.handlers.form.load
                    });
                }
            }
        },
        equipmentGridItemDataBound: function (args) {

            var rb = cafm.views.getMainFormViewModel();

            if (!rb.IsReadOnly) {

                args.sender.element.off('click.cafm').on('click.cafm', '.removeLink', cafm.rb.eq.handlers.removeEquipment);
                args.sender.element.on('click.cafm', '.editLink', cafm.rb.eq.handlers.editEquipmentGridItem);
            }
        },
        removeEquipment: function (args) {

            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#equipmentGrid').getGrid().data('kendoGrid');

            if (grid) {

                var eqItem = grid.dataItem(tr);

                if (eqItem) {

                    cafm.rb.eq.helpers.removeEquipment(eqItem);
                }
            }
        },
        search: function () {

            var criteria = $('#equipmentSwoFilters').getViewModel();

            $('#equipmentSwoGrid').setCriteria(criteria).refreshGridDataSource();
        },
        edit: {
                        
            cancel: function () {
                
                cafm.toolbar.standardActionToolbar.cancel();
            },
            ok: function () {

                var eqItem = cafm.views.getActionWindowViewModel();

                cafm.rb.eq.helpers.updateEquipment(eqItem);
            },
        },
        form: {

            isRequiredChanged: function(args){

                var grid = $('#equipmentRequestItemGrid').getGrid().data('kendoGrid');

                if (grid) {
                    
                    var chk = $(args.currentTarget),
                        tr = chk.parents('tr:first'),
                        eqItem = grid.dataItem(tr);

                    if (eqItem) {

                        eqItem.IsRequired = chk.prop('checked');
                    }
                }
            },
            itemGridDataBound: function (args) {
                
                var eqr = cafm.rb.eq.getEquipmentRequestViewModel();

                if (!eqr.get('RenderingClashes')) {

                    var reqChks = args.sender.element.find('.isRequiredCheckbox'),
                        rb = cafm.views.getMainFormViewModel(),
                        serverDateTime = cafm.rb.form.helpers.ensureServerBookingDates(rb);

                    reqChks.setupCheckbox();
                    args.sender.element.off('change.cafm').on('change.cafm', '.isRequiredCheckbox', cafm.rb.eq.handlers.form.isRequiredChanged);

                    if (serverDateTime) {

                        rb.set(serverDateTime);
                    }

                    rb = rb.toJSON();

                    if (!rb.Equipment || !cafm.util.exists(rb.Equipment, function (er) { return er.ID == eqr.ID })) {

                        if (!rb.Equipment) rb.Equipment = [];

                        rb.Equipment.push(eqr);
                    }
                    else {

                        var index = cafm.util.indexOf(rb.Equipment, function (er) { return er.ID == eqr.ID });
                        rb.Equipment[index] = eqr;
                    }

                    // perform the clash detection on server
                    cafm.actions.execute({

                        url: cafm.url.api('RoomBooking/ClashDetectEquipment'),
                        values: {
                            RoomBooking: rb,
                            EquipmentRequestId: eqr.ID
                        },
                        loaderSelector: '#editEquipment',
                        loaderText: 'Checking equipment availability...',
                        executeDelay: true,
                        statusCodeFuncs: {

                            409: function (res) {

                                eqr.set('RenderingClashes', true);

                                if (cafm.util.hasItem(res)) {

                                    reqChks.each(function (i, el) {

                                        var chk = $(el),
                                            tr = chk.closest('tr'),
                                            eqi = args.sender.dataItem(tr),
                                            clash = eqi ? cafm.util.find(res, function (c) { return c.ID == eqi.AssetId; }) : null;

                                        // if there's a clash prevent selection and display info
                                        if (clash) {

                                            // block selection
                                            chk.setCheckboxDisabled(true);

                                            // uncheck and suppress change event
                                            // we do this as changing the time can invalidate assets
                                            if (chk.isChecked()) {

                                                chk.setChecked(false);
                                            }

                                            // add clash class
                                            tr.addClass('clashingSelectItem');

                                            // add clash info
                                            tr.children('td').last().append($('<span/>', {
                                                'class': 'clashingItemDesc',
                                                text: '{0} {1} - {2}'.format(cafm.res.str.LabelUnavailable, cafm.util.toDateString(clash.Starts, 'g'), cafm.util.toDateString(clash.Ends, 't'))
                                            }))
                                        }
                                    });
                                }
                            }
                        },
                        complete: function () {
                            
                            eqr.set('RenderingClashes', false);
                        }
                    });
                }
            },
            load: function (panel) {

                var actionForm = cafm.views.getActionForm(),
                    roomBooking = cafm.views.getMainFormViewModel(),
                    eqr = cafm.rb.eq.getEquipmentRequestViewModel();

                var enableTimeFields = function (flag) {

                    var tps = actionForm.getTimePickers();

                    if (cafm.util.hasItem(tps)) {

                        tps.forEach(function (tp) {

                            tp.enable(flag);
                        });
                    }
                }

                if (eqr.UseMeetingTimes) {

                    enableTimeFields(false);
                }

                eqr.bind('change', function (args) {

                    var obj = isObj(args.sender.source) ? args.sender.source : args.sender;

                    if (args.field == 'UseMeetingTimes') {

                        enableTimeFields(!obj.UseMeetingTimes);
                    }

                    if (obj.UseMeetingTimes) {

                        eqr.set('FromTime', roomBooking.StartDateTime);
                        eqr.set('ToTime', roomBooking.EndDateTime);
                    }
                });

                var refreshItems = function () {

                    $('#equipmentRequestItemGrid').refreshGridDataSource();
                };

                actionForm.getTimePickers().forEach(function (tp) {

                    tp.bind('change', refreshItems);
                });

                $('#UseMeetingTimes').on('change', function () {

                    if ($(arguments[0].currentTarget).prop('checked')) {

                        refreshItems();
                    }
                });

                $('.winButtons .btn[data-key="Add"]').show();
            }
        }
    },
    helpers: {

        addEquipment: function (eqSwo) {

            var roomBooking = cafm.views.getMainFormViewModel();

            var exists = cafm.util.exists(roomBooking.Equipment.toJSON(), function (s) {

                return s.ID == eqSwo.ID;
            });

            if (!exists) {

                $('#selectEquipmentSwo').hide();

                $('#editEquipment').loadView({
                    url: cafm.url.get('RoomBooking/NewEquipmentRequest/{0}', eqSwo.ID),
                    onInit: cafm.rb.eq.handlers.form.init,
                    onLoad: cafm.rb.eq.handlers.form.load,
                    isForm: true
                }).show();
            }
        },
        ensureIsRequired: function (eqReq) {

            var valid = false;
            var gridDs = $('#equipmentRequestItemGrid').getDataSource();

            gridDs.data().forEach(function (item) {

                var match = cafm.util.find(eqReq.Items, function (tmpItem) {

                    return tmpItem.ID == item.ID;
                });

                if (match) {

                    match.IsRequired = item.IsRequired;

                    if (!valid && item.IsRequired) {

                        valid = true;
                    }
                }
            });

            if (!valid) {

                $('#editEquipment').showMessage({

                    Type: cafm.enums.MessageType.Error,
                    Title: cafm.res.str.MessageSelectAtLeaseOneItem
                });
            }

            return valid;
        },
        isRequiredCheckbox: function(isRequired){

            var guid = cafm.guid.newGuid(), str = ['<input id="{0}" type="checkbox" class="k-checkbox isRequiredCheckbox"'.format(guid)];
            
            if (isRequired) {

                str.push(' checked');
            }
            
            str.push(' />');
            str.push('<label class="k-checkbox-label" for="{0}"></label>'.format(guid));

            return str.join('');
        },
        refreshEquipment: function () {

            $('#equipmentGrid').refreshGridDataSource();

            // refresh clashes if any
            cafm.rb.form.helpers.showClashesIfAny();
        },
        removeEquipment: function (eqItem) {

            var roomBooking = cafm.views.getMainFormViewModel();

            var eqOnBooking = cafm.util.find(roomBooking.Equipment, function (ei) {

                return ei.ID == eqItem.ID;
            });

            if (eqOnBooking) {

                eqOnBooking.set('IsDeleted', true);
            }

            // refresh the equipment
            cafm.rb.eq.helpers.refreshEquipment();
        },
        updateEquipment: function (eqr) {
            
            var roomBooking = cafm.views.getMainFormViewModel();
            var existing = cafm.util.find(roomBooking.Equipment, function (er) {

                return er.ID == eqr.ID;
            });

            if (existing) {

                if (!cafm.rb.eq.helpers.ensureIsRequired(eqr)) {

                    return;
                }

                // ensure correct dates
                if (isDate(eqr.FromTime)) {

                    eqr.FromTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                    eqr.FromTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                }

                if (isDate(eqr.ToTime)) {

                    eqr.ToTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                    eqr.ToTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                }

                existing.FromTime = eqr.FromTime;
                existing.ToTime = eqr.ToTime;
                existing.UseMeetingTimes = eqr.UseMeetingTimes;
                existing.RequestNotes = eqr.RequestNotes;
                existing.Items = eqr.Items;

                // refresh the equipment
                cafm.rb.eq.helpers.refreshEquipment();
            }

            cafm.views.closeActionWindow();
        }
    }
}